import {
  BadgeDollarSignIcon,
  BrickWallIcon,
  ClipboardListIcon,
  HomeIcon,
  UsersIcon,
  FlowerIcon,
  ScissorsIcon,
  SproutIcon,
  SparklesIcon,
  FenceIcon,
  WavesIcon,
  DropletsIcon,
  Trash2Icon,
  ShieldCheckIcon,
  BadgeCheckIcon,
  MapPinIcon,
  HeartHandshakeIcon,
  SquareStackIcon,
} from 'lucide-react';

export const business = {
  name: 'Dany Landscaping Stone Work',
  phoneDisplay: '(346) 369-4236',
  phoneHref: 'tel:3463694236',
  smsNumber: '+13463694236',
  whatsappNumber: '13463694236',
  logo: 'https://cdn.magicpatterns.com/uploads/vhULafKMGNCzfKfbFuoges/Photoroom_20261005_125416.png',
  hero: 'https://cdn.magicpatterns.com/uploads/43ju4edpMRX5aMcMDn2Qis/dany1.png',
};

export const serviceAreas = [
  'Forney',
  'Crandall',
  'Sunnyvale',
  'Mesquite',
  'Rockwall',
  'Waxahachie',
  'Rowlett',
  'Plano',
  'Wayne',
];

export const serviceAreaLocations: { name: string; lat: number; lng: number }[] = [
  { name: 'Plano', lat: 33.0198, lng: -96.6989 },
  { name: 'Wayne', lat: 33.0151, lng: -96.5389 },
  { name: 'Rowlett', lat: 32.9029, lng: -96.5639 },
  { name: 'Rockwall', lat: 32.9312, lng: -96.4597 },
  { name: 'Sunnyvale', lat: 32.7965, lng: -96.5608 },
  { name: 'Mesquite', lat: 32.7668, lng: -96.5992 },
  { name: 'Forney', lat: 32.7482, lng: -96.4719 },
  { name: 'Crandall', lat: 32.6279, lng: -96.4558 },
  { name: 'Waxahachie', lat: 32.3866, lng: -96.8483 },
];

export const trustBadges = [
  { label: 'Licensed', icon: BadgeCheckIcon },
  { label: 'Insured', icon: ShieldCheckIcon },
  { label: 'Local', icon: MapPinIcon },
  { label: 'Family-Owned', icon: HeartHandshakeIcon },
];

export const benefits = [
  {
    title: 'Transparent Pricing',
    body: 'Free estimate, no hidden fees.',
    icon: BadgeDollarSignIcon,
  },
  {
    title: 'Stone Work Specialists',
    body: 'Flower bed stone, concrete, and hardscaping that transforms a property.',
    icon: BrickWallIcon,
  },
  {
    title: 'One Call Handles It All',
    body: 'From lawn care to drainage, one team does the whole job.',
    icon: ClipboardListIcon,
  },
  {
    title: 'Local Accountability',
    body: 'We live here. If something’s wrong, we fix it.',
    icon: HomeIcon,
  },
  {
    title: 'Same Team, Every Time',
    body: 'The same people who care about your property, every visit.',
    icon: UsersIcon,
  },
];

export const featuredServices = [
  {
    title: 'Flower Bed Stone & Mulch',
    body: 'Natural stone borders, fresh mulch, and planting that frames your home.',
    icon: FlowerIcon,
    image: 'https://cdn.magicpatterns.com/uploads/p2ety9nvm4XcYcCq2sAXg1/dany3.png',
    alt: 'Curved white limestone flower bed and tree ring with fresh mulch in front of a brick home',
  },
  {
    title: 'Concrete & Driveways',
    body: 'Driveways, walkways, and patios poured clean and built to last.',
    icon: SquareStackIcon,
    image: 'https://cdn.magicpatterns.com/uploads/mEPH9t4RFKVBfaXbrkcQVh/dany11.png',
    alt: 'New concrete driveway with a stepping-stone and gravel side path lined with lights',
  },
  {
    title: 'Fences & Stone Walls',
    body: 'Cedar fences and stone retaining walls that finish the yard.',
    icon: FenceIcon,
    image: 'https://cdn.magicpatterns.com/uploads/7TMn5YeWe1ENNtLhWQ99Bo/dany4.png',
    alt: 'Stained cedar fence behind a mulched bed with a sandstone retaining wall and green lawn',
  },
];

export const moreServices = [
  { label: 'Lawn Care & Trimming', body: 'Regular mowing, edging, and shaping.', icon: ScissorsIcon },
  { label: 'Water Drainage', body: 'French drains that keep water off your foundation.', icon: DropletsIcon },
  { label: 'Sod Installation', body: 'From bare dirt to a full green lawn in a day.', icon: SproutIcon },
  { label: 'Power Washing', body: 'Driveways, fences, and patios like new.', icon: WavesIcon },
  { label: 'Spring Cleanup', body: 'Trimming, clearing, and seasonal refresh.', icon: SparklesIcon },
  { label: 'Debris Removal', body: 'We haul it all away, nothing left behind.', icon: Trash2Icon },
];
